import type { NuxtError } from "nuxt/app";
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded } from "vue-router";
import type { AuthCheckParams } from "~/modules/nuxt3-module-doyac/composables/auth";
import { useUtils, type MakeAuthMiddlewareOptions } from "~/modules/nuxt3-module-doyac/composables/utils";
import { useDYMainStore } from "~/modules/nuxt3-module-doyac/stores/main";
import { useDYUserStore } from "~/modules/nuxt3-module-doyac/stores/user";
import { useIGUserStore } from "~/modules/nuxt3-module-ingang/stores/user";
import { useMainStore } from "~/stores/main";
import { useUserStore } from "~/stores/user";

/**
 * 페이지 키 생성 함수. 관리자용은 마지막 `useFullPath` 인자의 기본값으로 `true`를 사용함에 유의!! // 마퍼가만 기존에 true였는데 문제가 있어서 260326기준으로 false로 변경(메시지 내역 같은 경우 검색된 chip을 삭제해도 적용이 안됨) + 추가로 특정 페이지에서 모달 이상작동 문제도 발생함
 * @param route 
 * @param withSearchParamNames 
 * @param useFullPath 
 * @returns 
 */
export function $dy__makePageKey(route: RouteLocationNormalizedLoaded, withSearchParamNames: string[] = [], useFullPath: boolean = false) {
  const { makePageKey } = useUtils()
  return makePageKey(route, withSearchParamNames, useFullPath)
}

export function $dy__showPageError(error: Error | string | Partial<NuxtError>, url: string | RouteLocationNormalized, useThrow = false) {
  const { showPageError } = useUtils()
  showPageError(error, url, useThrow)
}

export function $dy__useDYUserStore() {
  const parent = useDYUserStore()
  // @ts-ignore
  return useUserStore() as typeof parent
}

export function $dy__useIGUserStore() {
  const parent = useIGUserStore()
  return useUserStore() as typeof parent
}

export function $dy__useDYMainStore() {
  const parent = useDYMainStore()
  return useMainStore() as typeof parent
}

export function $dy__notifyError(error: string | NuxtError<unknown>) {
  const { notifyError } = useUtils()
  return notifyError(error)
}

export function $dy__auth(auth?: string | AuthCheckParams | boolean, opts?: MakeAuthMiddlewareOptions) {
  const { makeAuthMiddleware } = useUtils()
  return makeAuthMiddleware(auth, opts)
}